// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"43271773","453":"8ebb2a30","455":"8d3c5129","977":"3e761c13"}[chunkId] + ".chunk.js";
};